import styled from "styled-components";

import { tableStyle } from "./BaseTableStyle";

const ActionTableHtmlStyle = styled.table`
    // Vanilla style provides a decoupled styles from the styling library in use.
    ${tableStyle};
`;
const ActionTableContainerHtmlStyle = styled.div`
    // Vanilla style provides a decoupled styles from the styling library in use.
    ${tableStyle};
`;

export const HtmlTableStyle = styled(ActionTableHtmlStyle).attrs(() => ({ className: "aevi-table" }))``;
export const HtmlTableContainerStyle = styled(ActionTableContainerHtmlStyle).attrs(() => ({ className: "aevi-table-container" }))``;
export const HtmlPaginationStyle = styled(ActionTableHtmlStyle).attrs(() => ({ className: "aevi-table-pagination" }))``;
